import gsap from 'gsap'
import SplitType from 'split-type'

export function imageRevealAnimation() {
  const imagesWrapper = document.querySelectorAll('.block__top-side-image-wrapper')
  imagesWrapper.forEach((imageWrapper, idx) => {
    if (idx === 0 || imageWrapper.classList.contains('dont-animate')) return

    const image = imageWrapper.querySelector('img')
    const tl = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: imageWrapper,
        start: 'top 80%',
        toggleActions: 'play none none none',
        // onEnter() {
        //   if (!window.pageLoadAnimationCompleted && idx === 0) {
        //     tl.pause(0)
        //   }
        // },
      },
    })

    /**
    // If this is the first image, play the animation when pageLoadAnimationCompleted is dispatched.
    // This is needed because the animation is paused when the page first loads, and it needs
    // to be played when the page transition animation has finished.
     */
    // idx === 0 && window.addEventListener('pageLoadAnimationCompleted', () => tl.play())

    gsap.set(imageWrapper, {
      overflow: 'hidden',
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      transformOrigin: 'left',
    })
    gsap.set(image, { overflow: 'hidden', x: '0%', transformOrigin: 'left' })

    tl.from(
      imageWrapper,
      {
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
        duration: 1,
        ease: 'power2.out',
      },
      0
    )
    tl.from(
      image,
      {
        opacity: 0,
        x: '-50%',
        duration: 1,
        ease: 'power2.out',
      },
      0
    )
  })
}

export function headingAnimation() {
  const headings = document.querySelectorAll('h1, h2')

  headings.forEach((heading, idx) => {
    if (idx === 0 || heading.classList.contains('dont-animate')) return

    const splitText = new SplitType(heading as HTMLElement, {
      types: ['chars', 'words', 'lines'],
    })
    const { lines, words } = splitText

    const tl = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: heading,
        start: 'top 80%',
        toggleActions: 'play none none none',
        // onEnter() {
        //   if (!window.pageLoadAnimationCompleted && idx === 0) {
        //     tl.pause(0)
        //   }
        // },
      },
    })

    // idx === 0 && window.addEventListener('pageLoadAnimationCompleted', () => tl.play())

    gsap.set(lines, { overflow: 'hidden', clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)' })

    tl.fromTo(
      words,
      {
        yPercent: 100,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        stagger: 0.15,
        duration: 1,
        ease: 'power2.out',
      }
    )
  })
}
